/**
 * Banner crop is saved at the mobile frame aspect.
 * Desktop banner (wider) uses object-cover → top/bottom of this image are cropped,
 * so the clear center band is what computers show (VK cover-editor model).
 */
export const PROFILE_BANNER_MOBILE_ASPECT = 390 / 256;
export const PROFILE_BANNER_DESKTOP_ASPECT = 1130 / 320;

/** Outer crop frame aspect (uploaded image). */
export const PROFILE_BANNER_CROP_ASPECT = PROFILE_BANNER_MOBILE_ASPECT;

/**
 * Share of crop height visible on desktop (center band).
 * Gray top+bottom = mobile-only regions inside the same frame.
 */
export const PROFILE_BANNER_DESKTOP_HEIGHT_RATIO =
  PROFILE_BANNER_MOBILE_ASPECT / PROFILE_BANNER_DESKTOP_ASPECT;

/** Avatar on profile is square with rounded-3xl corners. */
export const PROFILE_AVATAR_CROP_ASPECT = 1;
